type Props = {
  title: string;
};

export const HeaderTitle = ({ title }: Props) => {
  return <h1 className='heading-700 text-center text-offWhite'>{title}</h1>;
};
